export const AnchorLinks = (function () {
	'use strict';

	function init() {
		if (window.location.hash.length > 1) scrollToTarget(window.location.hash);

		document.querySelectorAll('a').forEach((l) => {
			l.addEventListener('click', (ev) => scrollToTarget(l.hash, ev));
		});
	}

	function scrollToTarget(hash, event) {
		const targetEl = document.getElementById(hash.replace('#', ''));

		if (targetEl && !targetEl.classList.contains('modal')) {
			if (event) event.preventDefault();
			window.scrollTo({
				top: targetEl.offsetTop + 5,
				behavior: 'smooth',
			});
		}
	}

	return {
		init: init,
	};
})();
